<div class="form-container">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div *ngIf="flag.isEditing && form.controls.is_enabled.touched && !form.controls.is_enabled.value" class="row">
      <div class="vox-inline-message vox-inline-message_light-grey">
        <div>
          <i class="icon-small-alert"></i>
          <span translate>internal-facilities.feature-flags.form.is_enabled.info</span>
        </div>
      </div>
    </div>
    <div *ngIf="flag.isEditing" class="row">
      <div class="col-sm d-flex justify-content-between">
        <label class="mb-0 d-flex align-items-center" for="is_enabled">
          {{ 'internal-facilities.feature-flags.form.is_enabled.label' | translate }}
          <span
            class="ml-1 icon-small-info"
            placement="top"
            container="body"
            [ngbTooltip]="'internal-facilities.feature-flags.form.is_enabled.tooltip' | translate"
          ></span>
        </label>
        <vox-toggle
          formControlName="is_enabled"
          [toggleOn]="form.controls.is_enabled.value"
          [config]="{isAquamarine: true}">
        </vox-toggle>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <label class="d-flex align-items-center" for="key" translate>
          {{ 'internal-facilities.feature-flags.form.key.label' | translate }}
          <span 
            class="ml-1 icon-small-info"
            placement="top"
            container="body"
            [ngbTooltip]="'internal-facilities.feature-flags.form.key.tooltip' | translate"
          ></span>
        </label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('key')
        }">
          <input class="vox-text-field" type="text" id="key" formControlName="key" [placeholder]="'internal-facilities.feature-flags.form.key.placeholder' | translate" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span *ngIf="form.controls.key.errors?.required" class="vox-input-group__error-message" translate>
              internal-facilities.feature-flags.form.key.validation.required
            </span>
            <span *ngIf="form.controls.key.errors?.pattern" class="vox-input-group__error-message" translate>
              internal-facilities.feature-flags.form.key.validation.pattern
            </span>
            <span *ngIf="form.controls.key.errors?.exists" class="vox-input-group__error-message" translate>
              internal-facilities.feature-flags.form.key.validation.exists
            </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <label for="description" translate>internal-facilities.feature-flags.form.description.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('description')
        }">
          <textarea class="vox-text-field" type="text" id="description" rows="5" formControlName="description" [placeholder]="'internal-facilities.feature-flags.form.description.placeholder' | translate"></textarea>
          <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
          <span *ngIf="form.controls.description.errors?.required" class="vox-input-group__error-message" translate>
            internal-facilities.feature-flags.form.description.validation.required
          </span>
          <span *ngIf="form.controls.description.errors?.pattern" class="vox-input-group__error-message" translate>
              internal-facilities.feature-flags.form.description.validation.pattern
            </span>
        </div>
      </div>
    </div>
    <div class="submit-container">
      <button *ngIf="!flag.isEditing"
        class="vox-btn vox-btn-primary"
        [ladda]="_loading"
        data-spinner-color="grey"
        data-style="zoom-in"
        [disabled]="!canSubmit"
        type="submit">
        {{'company.user.form.submit-add' | translate}}
      </button>
      <button *ngIf="flag.isEditing"
        class="vox-btn vox-btn-primary"
        [ladda]="_loading"
        data-spinner-color="grey"
        data-style="zoom-in"
        [disabled]="!canSubmit"
        type="submit">
        {{'company.user.form.submit-edit' | translate}}
      </button>
    </div>
  </form>
</div>
